export const SET_REDUCER='SET_REDUCER'
export const SET_FORUM_LIST='SET_FORUM_LIST'

